import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { register as apiRegister } from '../services/api';
import { useAuth } from '../hooks/useAuth';

export default function RegisterPage() {
  const { refreshUser } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await apiRegister(email, password);
      await refreshUser();
      navigate('/receipts');
    } catch (err) {
      // A 404 here means public registration was disabled between page load
      // and submit — same message a user would see if the route never existed.
      setError(err.response?.data?.error || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--color-bg)',
      padding: '1rem',
      boxSizing: 'border-box',
    }}>
      <div className="card" style={{ width: '100%', maxWidth: 360 }}>
        <h1 style={{ marginBottom: '0.25rem' }}>Create account</h1>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1rem' }}>
            <label htmlFor="register-email" style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>Email</label>
            <input
              id="register-email"
              name="username"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div>
          <div style={{ marginBottom: '1rem' }}>
            <label htmlFor="register-password" style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>Password</label>
            <input
              id="register-password"
              name="new-password"
              type="password"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={12}
            />
            <p className="muted" style={{ fontSize: 12, marginTop: 4 }}>At least 12 characters.</p>
          </div>
          {error && <p className="error">{error}</p>}
          <button
            type="submit"
            className="btn-primary"
            disabled={loading}
            style={{ width: '100%', padding: '0.65rem', marginTop: '0.5rem' }}
          >
            {loading ? 'Creating account…' : 'Create account'}
          </button>
        </form>
        <p className="muted" style={{ fontSize: 13, marginTop: '1rem', textAlign: 'center' }}>
          <Link to="/login">Already have an account? Sign in</Link>
        </p>
      </div>
    </div>
  );
}
